import Request from "@/Request";

export function incomeList(payload) {
  return Request({
    url: "/reports/income",
    method: "get",
    params: payload,
  });
}